import React from 'react';
import styles from './Share.module.css';

// ============================================================
// SharePreview — the display block of a recipe package, shown as a page
// ============================================================
// Used by both dialogs: on the way out it is "exactly what will be
// published", and on the way in it is what the cook is about to add. Mesa
// Robles renders the same block, so this is a readable rehearsal of its page,
// not a second idea of the recipe.
export default function SharePreview({ display }) {
  if (!display) return null;
  const safety = display.safety;

  return (
    <div className={styles.scroll}>

      <div className={styles.block}>
        <div className={styles.pageTitle}>{display.title}</div>
        {display.subtitle && <div className={styles.pageSubtitle}>{display.subtitle}</div>}
        {display.summary && <div className={styles.pageSummary}>{display.summary}</div>}
      </div>

      {display.facts?.length > 0 && (
        <div className={styles.block}>
          <div className={styles.blockTitle}>At a glance</div>
          {display.facts.map((f, i) => (
            <div key={i} className={styles.factRow}>
              <span className={styles.factLabel}>{f.label}</span>
              <span className={styles.factValue}>{f.value}</span>
            </div>
          ))}
          {display.timing?.serves && (
            <div className={styles.factRow}>
              <span className={styles.factLabel}>Serves</span>
              <span className={styles.factValue}>{display.timing.serves}</span>
            </div>
          )}
        </div>
      )}

      {display.ingredientGroups?.length > 0 && (
        <div className={styles.block}>
          <div className={styles.blockTitle}>Ingredients</div>
          {display.ingredientGroups.map((g, gi) => (
            <div key={gi} className={styles.group}>
              <div className={styles.groupName}>{g.group}</div>
              {g.items.map((it, ii) => (
                <React.Fragment key={ii}>
                  <div className={styles.item}>
                    <span>{it.name}</span>
                    <span className={styles.itemQty}>{it.quantity || '—'}</span>
                  </div>
                  {it.note && <div className={styles.itemNote}>{it.note}</div>}
                </React.Fragment>
              ))}
            </div>
          ))}
        </div>
      )}

      {safety && (
        <div className={styles.block}>
          <div className={styles.blockTitle}>Safety</div>
          {safety.cure.map((c, i) => (
            <div key={i} className={styles.safetyRow}>
              {c.name}{c.amountText ? ` — ${c.amountText}` : ''}
            </div>
          ))}
          {safety.nitrite && (
            <div className={styles.safetyRow}>
              Nitrite:{' '}
              <span className={safety.nitrite.level === 'OK' ? styles.ppmOk : styles.ppmOver}>
                {safety.nitrite.text}
              </span>
              {safety.nitrite.basis ? ` · ${safety.nitrite.basis}` : ''}
            </div>
          )}
          {safety.disclaimer && <div className={styles.disclaimer}>{safety.disclaimer}</div>}
        </div>
      )}

      {display.methodSections?.length > 0 && (
        <div className={styles.block}>
          <div className={styles.blockTitle}>Method</div>
          {display.methodSections.map((sec, si) => (
            <div key={si}>
              <div className={styles.phase}>{sec.phase}</div>
              {sec.steps.map((st, sti) => (
                <div key={sti} className={styles.step}>{sti + 1}. {st}</div>
              ))}
            </div>
          ))}
        </div>
      )}

      {display.rescaleNote && (
        <div className={styles.block}>
          <div className={styles.disclaimer}>{display.rescaleNote}</div>
        </div>
      )}
    </div>
  );
}
